import React, { useState, useEffect } from 'react';
import './GeneralCalendar.css';

const GeneralCalendar = () => {
    // Використовуємо поточний рік
    const [year, setYear] = useState(new Date().getFullYear());

    useEffect(() => {
        // Оновлюємо рік якщо змінився (на випадок довгої сесії)
        setYear(new Date().getFullYear());
    }, []);

    const monthData = [
        { name: "Січень", icon: "❄️" },
        { name: "Лютий", icon: "🌨️" },
        { name: "Березень", icon: "🌷" },
        { name: "Квітень", icon: "🌸" },
        { name: "Травень", icon: "🌱" },
        { name: "Червень", icon: "🍒" },
        { name: "Липень", icon: "☀️" },
        { name: "Серпень", icon: "🌾" },
        { name: "Вересень", icon: "🌧️" },
        { name: "Жовтень", icon: "🍁" },
        { name: "Листопад", icon: "🍂" },
        { name: "Грудень", icon: "🎄" }
    ];

    // Понеділок - початок тижня
    const weekDaysUA = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Нд"];

    const getDaysInMonth = (monthIndex) => {
        return new Date(year, monthIndex + 1, 0).getDate();
    };

    const getFirstDayOfMonth = (monthIndex) => {
        const day = new Date(year, monthIndex, 1).getDay();
        // JS повертає 0 для Неділі. Нам треба 0 для Понеділка.
        // Нд (0) -> 6
        // Пн (1) -> 0
        return (day + 6) % 7;
    };

    const isPast = (monthIndex, day) => {
        const date = new Date(year, monthIndex, day);
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        return date < now;
    };

    const isToday = (monthIndex, day) => {
        const date = new Date(year, monthIndex, day);
        const now = new Date();
        return date.getDate() === now.getDate() &&
            date.getMonth() === now.getMonth() &&
            date.getFullYear() === now.getFullYear();
    };

    return (
        <div className="general-calendar-container">
            <div className="calendar-header">
                <h1 className="year-title">{year}</h1>
            </div>
            <div className="months-grid">
                {monthData.map(({ name, icon }, monthIndex) => {
                    const daysInMonth = getDaysInMonth(monthIndex);
                    const firstDayOffset = getFirstDayOfMonth(monthIndex);

                    const days = [];
                    // Пусті клітинки на початку місяця
                    for (let i = 0; i < firstDayOffset; i++) {
                        days.push(<div key={`empty-${i}`} className="day-cell empty"></div>);
                    }

                    // Дні місяця
                    for (let d = 1; d <= daysInMonth; d++) {
                        const passed = isPast(monthIndex, d);
                        const todayIs = isToday(monthIndex, d);
                        const isChristmas = monthIndex === 11 && d === 25;
                        const isBirthday = monthIndex === 3 && d === 22;

                        days.push(
                            <div
                                key={d}
                                className={`day-cell ${passed ? 'crossed-out' : ''} ${todayIs ? 'today' : ''} ${isChristmas ? 'christmas-day' : ''} ${isBirthday ? 'birthday-day' : ''}`}
                                title={`${d} ${name}`}
                            >
                                {d}
                                {isChristmas && <span className="gift-icon">🎁</span>}
                                {isBirthday && <span className="gift-icon">🎂</span>}
                            </div>
                        );
                    }

                    return (
                        <div className="month-container" key={name}>
                            <div className="month-name">
                                <span className="month-number">{String(monthIndex + 1).padStart(2, '0')}</span>
                                {name}
                                <span className="month-icon">{icon}</span>
                            </div>
                            <div className="days-grid">
                                {weekDaysUA.map(day => (
                                    <div key={day} className="weekday-header">{day}</div>
                                ))}
                                {days}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default GeneralCalendar;
